import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { AppLanguage } from '../shared/AppLanguage';
import HttpBackend from 'i18next-http-backend';
const apiKey = '7KkJwMF6yCrHHTCxwTSLKw';
const loadPath = `https://api.i18nexus.com/project_resources/translations/{{lng}}/{{ns}}.json?api_key=${apiKey}`;

export const KAPINUA_NAMESPACE = 'default';
i18next
    .use(initReactI18next) // Pass i18n down to react-i18next, so this will make it available in React components
    .use(HttpBackend)
    .use({
        type: 'postProcessor',
        name: 'fallbackToEn',
        process: (value, key, options, translator) => {
            if (
                value === '___TRANSLATE_THIS___' &&
                translator.language !== AppLanguage.ENGLISH
            ) {
                return translator.translate(key, { lng: AppLanguage.ENGLISH });
            }

            return value;
        },
    })
    .init({
        supportedLngs: ['en', 'de'],
        backend: {
            loadPath: loadPath,
        },
        fallbackLng: [AppLanguage.ENGLISH, AppLanguage.DEUTSCH],
        defaultNS: KAPINUA_NAMESPACE,
        ns: KAPINUA_NAMESPACE,

        keySeparator: false, // We do not use keys in form messages.welcome
        nsSeparator: false, // We do not use color as ns separator, without this "Foo:" was malfunctioning

        interpolation: {
            escapeValue: false, // React already ensure XSS protection
        },
        react: {
            useSuspense: false,
        },
        postProcess: ['fallbackToEn'],
    });
export default i18next;
